const posthog = globalThis.posthog;

export { posthog };
